export const CUSTOMER = {
  name: "Loop",
  primaryColor: "#3a295c",
  primaryColorRGB: "58,41,92",
  primaryColorContrast: "#FFFFFF",
  primaryColorContrastRGB: "255,255,255",
  customerLogoLink: "https://dl.intheloop.io/loop_white.svg",
  leftSideContent: {
    title: "Supercharge your customer service",
    description:
      "An affordable customer operations platform for high-performing teams. Bring all your conversations into one workspace..",
    ticks: [
      "Centralize all your conversations",
      "Collaborate seamlessly with your team",
      "Automate workflows and save time",
    ],
    footerContent: "Trusted by teams worldwide",
  },
  rightSideContent: {
    footerContent: "© 2026 Loop. All rights reserved.",
    poweredByContent: "Powered by",
  },
  signupPage: {
    title: "Welcome!",
    description: "Create your account to get started",
  },
  loginPage: {
    title: "Welcome back",
  },
};
